;(function ($) {
  'use strict';

  $(document).ready(function() {
    keyboard_accessibility();
  });

  // Keyboard accessibility
  function keyboard_accessibility() {
    let $submenuToggles = $('.menu__submenu-toggle');
    let $mobileMenu = $('.menu-main-toggle');

    $(document).keydown(function (e) {
      let code = e.keyCode ? e.keyCode : e.which;

      // ESC behaviors
      if (code == 27) {
      }

      // TAB behaviors
      if (!e.shiftKey && code == 9) {
        // collapses submenu when the last link loses focus
        $('.main-menu > .menu-item > .menu__submenu > .submenu > .menu-item:last-child').each(function() {
          if ( $mobileMenu.css('display') == 'none' ) {
            if ( !$(this).find('.menu__submenu').length ) {
              $(this).find('> a').on({
                'blur': function() {
                  $(this).parents('.main-menu').find('> .has-children')
                    .removeClass('submenu--revealed')
                    .find(' > .menu__submenu').hide()
                    .prev('.menu__submenu-toggle').attr('aria-expanded', false);

                  $(this).parents('.has-children').find('.menu__submenu-toggle').attr('title', $(this).parents('.has-children').find('.menu__submenu-toggle').attr('title').replace('Close','Open'));
                }
              });
            }
            else {
              $(this).find('.menu-item:last-child > a').on({
                'blur': function() {
                  $(this).parents('.main-menu').find('> .has-children')
                    .removeClass('submenu--revealed')
                    .find(' > .menu__submenu').hide()
                    .prev('.menu__submenu-toggle')
                      .attr('aria-expanded', false);

                  $(this).parents('.has-children').find('.menu__submenu-toggle').attr('title', $(this).parents('.has-children').find('.menu__submenu-toggle').attr('title').replace('Close','Open'));
                }
              });
            }
          }
        });

        $('.header__toggable .menu-main-toggle').on({
          'blur': function() {
            $('.main-menu > .menu-item:first-child > .menu__submenu-toggle').focus();
          }
        });
      }

      // SHIFT + TAB behaviors
      if (e.shiftKey && code == 9) {

      }

      // ENTER behaviors
      if (code == 13) {

      }
    });
  }
})(jQuery);
